import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import router from './router';
import store from './store';
import NoticeText from '@/components/NoticeText.vue';
import PageNav from '@/components/PageNav.vue';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('NoticeText', NoticeText);
Vue.component('PageNav', PageNav);

// 设置弹框配置
['success', 'warning', 'info', 'error'].forEach(type => {
  ElementUI.Message[type] = (options) => {
    // 兼容直接传字符串的写法
    if(options === null){
      options = {};
    }
    if (typeof options === 'string') {
      options = { message: options };
    }
    // 设置全局默认配置
    options.duration = 1000; // 显示时长
    // 确保类型正确并返回
    options.type = type;
    return ElementUI.Message(options);
  };
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
